@if (data$ | async; as data) {
  <app-alerts />

  <app-public-order-shipping-address-form
    [data]="data"
    [orderNumber]="orderNumber()"
    [shipmentId]="shipmentId()"
    [pending]="pending()"
    (cancelClickEvent)="handleCancelClickEvent()"
    (submitClickEvent)="handleSubmitClickEvent($event)" />
} @else {
  <app-spinner-filled />
}
